import React from 'react'

const AddBoldIcon = React.lazy(() => import('./AddBoldIcon'))
const LinkIcon = React.lazy(() => import('./LinkIcon'))
const MultiSelect = React.lazy(() => import('./MultiSelect'))
const MultiText = React.lazy(() => import('./MultiText'))
const NumberIcon = React.lazy(() => import('./Number'))
const SelectIcon = React.lazy(() => import('./Select'))
const ShiftIcon = React.lazy(() => import('./ShiftIcon'))
const TextIcon = React.lazy(() => import('./Text'))
const UnlinkIcon = React.lazy(() => import('./UnlinkIcon'))
const GreenRightIcon = React.lazy(() => import('./GreenRight'))
const NormalFieldIcon = React.lazy(() => import('./NormalFieldIcon'))
const LinkNormalIcon = React.lazy(() => import('./linkNormalIcon'))
const UnLinkNormalIcon = React.lazy(() => import('./unLinkNormalIcon'))
const RedDeleteIcon = React.lazy(() => import('./RedDeleteIcon'))
const DragIcon = React.lazy(() => import('./DragIcon'))
const AreaIcon = React.lazy(() => import('./Area'))
const GeolocationIcon = React.lazy(() => import('./Geolocation'))
const StandardIcon = React.lazy(() => import('./Standard'))

const DittoIcons = {
  AddBoldIcon,
  LinkIcon,
  MultiSelect,
  MultiText,
  NumberIcon,
  SelectIcon,
  ShiftIcon,
  TextIcon,
  UnlinkIcon,
  GreenRightIcon,
  NormalFieldIcon,
  LinkNormalIcon,
  UnLinkNormalIcon,
  RedDeleteIcon,
  DragIcon,
  AreaIcon,
  GeolocationIcon,
  StandardIcon,
}

export {
  AddBoldIcon,
  LinkIcon,
  MultiSelect,
  MultiText,
  NumberIcon,
  SelectIcon,
  ShiftIcon,
  TextIcon,
  UnlinkIcon,
  GreenRightIcon,
  NormalFieldIcon,
  RedDeleteIcon,
  DragIcon,
  AreaIcon,
  GeolocationIcon,
  StandardIcon,
}

export default DittoIcons
